import {
    TextWrapper,
    Wrapper,
    CircleImage,
    Form,
    StyledButton,
} from "./styles";
import { Text } from "components/Text";
import { Input } from "components/Input";
import { useRegister } from "hooks/client/useRegister.hook";
import { Checkbox, Flex } from "antd";
import { Controller } from "react-hook-form";
import { Link } from "react-router-dom";
import { PodoUpLogotyp11Color } from "assets/icons";
import { REACT_APP_LOGO, REACT_TITLE } from "config/env";
import colors from "theme/colors.module.scss";
import spacing from "theme/spacing.module.scss";

const SignInView = () => {
    const {
        onSubmit,
        loading,
        error,
        control,
        isValid,
        formErrors
    } = useRegister();
    return (
        <Wrapper>
            <TextWrapper>
                {REACT_APP_LOGO ? (
                    <img src={REACT_APP_LOGO} alt="logo" className="main-logo" />
                ) : (
                    <PodoUpLogotyp11Color className="main-logo" />
                )}
                <Text $textVariant="pBold" style={{ zIndex: 1 }}>Zarejestruj się,</Text>
                <Text $textVariant="pBold" style={{ zIndex: 1 }}>aby korzystać z</Text>
                <Text $textVariant="pBold" style={{ zIndex: 1 }}>{REACT_TITLE}</Text>
                <CircleImage />
            </TextWrapper>
            <Form>
                <Input
                    placeholder="Imię *"
                    name="firstName"
                    control={control}
                    type="text"
                    autocomplete="off"
                    sanitizeInput
                    blockPaste
                />
                <Input
                    placeholder="Nazwisko *"
                    name="lastName"
                    control={control}
                    type="text"
                    autocomplete="off"
                    sanitizeInput
                    blockPaste
                />
                <Input
                    placeholder="Telefon *"
                    name="phone"
                    control={control}
                    type="text"
                    autocomplete="off"
                    sanitizeInput
                />
                <Input
                    placeholder="Hasło *"
                    name="password"
                    control={control}
                    type="password"
                    sanitizeInput
                    blockPaste
                />
                <Input
                    placeholder="Potwierdź hasło *"
                    name="confirmPassword"
                    control={control}
                    type="password"
                    sanitizeInput
                    blockPaste
                />
                <Controller
                    name="agreementAccepted"
                    control={control}
                    render={({ field, fieldState: { error: fieldError } }) => (
                        <Flex vertical style={{ marginBottom: spacing.spacingSM }}>
                            <Checkbox
                                checked={field.value}
                                onChange={(e) => field.onChange(e.target.checked)}
                            >
                                Zapoznałem/am się z{" "}
                                <a
                                    href="https://podoup.pl/regulamin_zenpilates.pdf"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    regulaminem
                                </a>
                                {" "}i go akceptuję
                            </Checkbox>
                            {fieldError && (
                                <span style={{ color: colors.accentRed500, fontSize: 12 }}>
                                    {fieldError.message}
                                </span>
                            )}
                        </Flex>
                    )}
                />
                <Flex vertical>
                    {error && <Text $textColor="accentRed500">{error}</Text>}
                    <StyledButton
                        onClick={onSubmit}
                        size="large"
                        type="primary"
                        disabled={!isValid}
                        loading={loading}
                    >
                        Zarejestruj się
                    </StyledButton>
                    <Flex justify="center" style={{ marginTop: spacing.spacingMD }} gap={spacing.spacingSM}>
                        <Text $textVariant="p">Masz już konto?{" "}</Text>
                        <Link to="/login">Zaloguj się</Link>
                    </Flex>
                </Flex>
            </Form>
        </Wrapper>
    );
};

export default SignInView;
